<template>
  <div class="page">
    <div class="top_nav_bg" id="index_page">
      <span style="width: 20rem;height: 20rem;font-size: 9rem;display: block;padding: 10rem;text-align: center;line-height: 20rem;color: rgb(230,154,72)">口&nbsp&nbsp袋</span>
      <img src="../assets/image/index/threeBG.png" alt="" style="width: 22%;height: 60%"/>
      <span style="width: 20rem;height: 20rem;font-size: 9rem;display: block;padding: 10rem;text-align: center;line-height: 20rem;margin-left: -2rem;color: rgb(230,154,72)">优&nbsp&nbsp选</span>
    </div>

<!--    <div class="top_nav_bg" id="index_page">-->
<!--      <img src="../assets/image/index/threeBG.png" alt="" style="width: 26%;height: 70%"/>-->
<!--      <span style="width: 20rem;height: 20rem;font-size: 9rem;display: block;padding: 4rem;text-align: center;line-height: 20rem;color: rgb(230,154,72)">口&nbsp&nbsp袋</span>-->
<!--      <span style="width: 20rem;height: 20rem;font-size: 9rem;display: block;padding: 5rem;text-align: center;line-height: 20rem;color: rgb(230,154,72)">优&nbsp&nbsp选</span>-->
<!--    </div>-->
    <div :class="flag===1?'top_box':'top_box_tow'">
      <div class="left_logo_nav">
        <div class="left_logo_box">
          <img src="../assets/image/index/smallLogo.jpg" style="width: 100%;height: auto" alt=""/>
        </div>
        <div class="left_nav_box">
          <ul style="display: flex;justify-content: space-evenly;align-items: center;margin-left: -3rem;">
            <li class="list_style"><a href="#index_page" class="list_a_style">首页</a></li>
            <li class="list_style"><a href="#special_fruits" class="list_a_style">今日特价</a></li>
            <li class="list_style"><a href="#hot_sale" class="list_a_style">热销商品</a></li>
            <li class="list_style"><a href="#all_sale" class="list_a_style">全部商品</a></li>
            <li class="list_style"><a href="#about_us" class="list_a_style">关于我们</a></li>
            <li class="list_style"><a href="#contact_us" class="list_a_style">联系我们</a></li>
          </ul>
        </div>
      </div>
      <div class="right_car_store" >
        <div @click="seeCar">
          <el-badge :value="allCount" :max="10" class="item" v-if="allCount>0">
            <img src="../assets/image/index/shoppingCart.png" alt="" style="width:1.5rem;height:1.25rem"/>
          </el-badge>

          <img src="../assets/image/index/shoppingCart.png" alt="" style="width:1.5rem;height:1.25rem" v-else/>
<!--          <span>{{allCount}}</span>-->
        </div>
        <a :class="flag===1?'show_store_btn':'other_store_btn'" href="#all_sale">查看商店</a>
      </div>
    </div>
    <div class="special_offer_fruits" id="special_fruits">
      <div class="special_offer_title">
        <span>今日特价</span>
      </div>
      <div class="special_fruits_box">
        <div class="one_special_offer" v-for="(item,index) in specialList" :key="index">
          <div class="special_fruits_image">
            <img :src="item.image" style="width: 18rem;height: 17.5rem; overflow:hidden;object-fit:cover;margin-top: 0.5rem"/>
          </div>
          <div style="width: 100%;text-align: center;padding: 0.5rem 0">
            <span>{{item.introduce}}</span>
          </div>
          <div style="width: 100%;text-align: center;color: #ff4400;font-size: 1.2rem;padding: 0.5rem 0">
            <span>￥{{item.price}}</span>
          </div>
          <div style="width: 100%;text-align: center;font-weight: 500;color: #999;font-size: 1rem;margin-top: 0.5rem;text-decoration:line-through">
            <span>原价:￥{{item.orPrice}}</span>
          </div>
          <div style="width: 100%;height: 3rem;display: flex;justify-content: right">
            <div style="width: 30%;height:2.5rem;background: rgb(1,203,101);border-radius: 1.5rem 0 0 1.5rem;display: flex;align-items: center;justify-content: center; cursor:hand;">
              <img src="../assets/image/index/left.png" style="width: 20%;height: auto"/>
              <span style="color: white;cursor: pointer;display: flex" @click="bugThing(item)">立即抢购</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hot_sale_fruits" id="hot_sale">
      <div class="sale_chinese_title">
        <span>热销商品</span>
      </div>
      <div class="sale_fruits_box">
        <div class="one_fruits_box" v-for="(item,index) in fruitList" :key="index">
          <img :src="item.image" style="width: 11.6rem;height: auto" alt=""/>
          <div style="width: 11.6rem;height: 2rem;text-align: center;line-height: 2rem;font-size: 1.25rem;margin-top: 2rem">
            <span id="all_sale">{{item.name}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="all_commodity_box" >
      <div class="all_chinese_title">
        <span>全部商品</span>
      </div>
      <div class="show_commodity_box">
         <div class="one_commodity_box" v-for="(item,index) in commodityList" :key="index" @mouseover="mouseOver(index+1)" @mouseleave="mouseLeave(index+1)" name="face">
           <img :src="item.image" style="width: 23.5rem;height: 17.5rem; overflow:hidden;object-fit:cover;margin-top: 0.5rem" />
           <div  :class="mouseIndex===index+1?'one_mask_commodity':''">
             <div :class="mouseIndex===index+1?'bug_btn':'bug_btn_tow'">
               <a class="button_style" @click="bugThing(item)">立即购买</a>
             </div>
           </div>

           <div style="width: 100%;text-align: center;letter-spacing: 2.4px;">
             <span>{{ item.name }}</span>
           </div>
           <div style="width: 100%;text-align: center;color: #8c939d;font-size: 0.8rem">
             <span>{{ item.introduce }}</span>
           </div>
           <div style="width: 100%;text-align: center;font-weight: 500;color: #ff4400;font-size: 1rem;margin-top: 0.5rem">
             <span>￥{{ item.price }}</span>
           </div>

         </div>
      </div>
      <div class="see_more_commodity">
        <span @click="seeMore" style="color: #3a8ee6; text-decoration: underline;" v-if="haveMore">查看更多>></span>
      </div>
    </div>
    <div class="logistics_box" id="logistics">
      <div style="width: 84%;height: 3rem;padding: 1rem;text-align: left;margin: 0 auto;font-size: 1.5rem;">
        <span>物流</span>
      </div>
      <div style="width: 84%;height: 23rem;margin: 0 auto;display: flex;justify-content: center;background-color: white">
        <div class="truck_and_word">
          <div class="logistics_word_box">
            <div class="word_bottom_box">
              <span style="display:block ">您在本商品页购买商品后</span>
              <span style="display:block ">我们将在付款后的24小时内将您的包裹寄出</span>
              <span style="display:block ">发出时，您的手机将会收到包裹的物流短息</span>
              <span style="display:block " id="join_us">请务必注意手机物流短信</span>
            </div>
          </div>
          <div style="width: 4rem;background-color: rgb(245,241,241);height: 4rem;border-radius: 50%;margin-top: 10rem"></div>
          <div style="width: 2rem;background-color: rgb(245,241,241);height: 2rem;border-radius: 50%;margin-top: 15rem"></div>
          <div style="width: 1rem;background-color: rgb(245,241,241);height: 1rem;border-radius: 50%;margin-top: 18rem"></div>
          <div class="truck_image_box">
            <img src="../assets/image/index/truck.png" alt="" style="width: 100%;height: 18.3rem;margin-top: 4.5rem" />
          </div>
        </div>
      </div>

    </div>
    <div class="about_us_box" id="about_us">
      <div class="about_chinese_title">
        <span>关于我们</span>
      </div>
      <div class="about_us_content">
        <span>厦门口袋零钱网络科技有限公司成立于2015年9月28日，落座于厦门市思明区软件园二期，是一家以公益性服务与经营性服务相融合发展的农业生产性服务公
              司。 口袋优选秉承“质量第一、信誉第一、客户至上”为宗旨，专注于食材精选、生产、加工、包装、运输等专业化服务、为各大星级酒店及大型餐饮、
              商超提供优质的禽肉蛋、海鲜果蔬产品。“诚实守信”是我们的经营宗旨，我们愿与广大客户真诚合作，携手共进，共谋发展，创建美好未来。</span>
      </div>
    </div>

<!--    <div class="join_us_box" >-->
<!--      <div class="join_chinese_title">-->
<!--        <span>加入会员</span>-->
<!--      </div>-->
<!--      <div class="join_english_title">-->
<!--&lt;!&ndash;        <span>JOIN THE MEMBERSHIP</span>&ndash;&gt;-->
<!--      </div>-->
<!--      <div class="join_email_box">-->
<!--        <el-form :inline="true" :model="formInline" class="demo-form-inline" v-if="submit===1">-->
<!--          <el-form-item label="">-->
<!--            <el-input v-model="formInline.user" placeholder="名字"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="" id="contact_us">-->
<!--            <el-input v-model="formInline.email" placeholder="邮箱"></el-input>-->
<!--            <div style="margin-left: -7rem" v-if="unEmail">请输入正确的邮箱</div>-->
<!--          </el-form-item>-->

<!--          <el-form-item>-->
<!--            <el-button @click="onSubmit" style="background-color: #ddc346;color: white" v-if="submitting===0">提交</el-button>-->
<!--            <el-button type="primary" :loading="true" style="background-color: #ddc346;color: white" v-if="submitting===1">提交</el-button>-->
<!--          </el-form-item>-->
<!--        </el-form>-->
<!--        <div class="think_for_submit" v-if="submit===0">-->
<!--           感谢提交-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="contact_and_map" >
      <div :class="leaveSubmit===0?'small_contact_map':'inside_contact_map'">
         <div class="contact_us_box">
            <div class="contact_english_title">
            </div>
           <div class="contact_chinese_title">
             <span>联系我们</span>
           </div>
           <div style="width: 33.2rem;height: 20.5rem;margin: 3rem auto;text-align: center;">
             <div v-if="leaveSubmit===1">
               <el-input type="text" placeholder="姓名" v-model="name" class="contact_name_input"></el-input>
               <el-input type="text" placeholder="邮箱" v-model="email" class="contact_name_input"></el-input>
               <div style="margin-left: -24rem;" v-if="leaveUnEmail">请输入正确的邮箱</div>
               <textarea placeholder="留言" class="contact_leaving_message" v-model="value" onblur="if (this.value === '') this.setAttribute('placeholder', '留言');" onfocus="this.setAttribute('placeholder', '');"></textarea>
               <button class="contact_submit_btn" @click="submitMessage" v-if="leaveSubmitting===0">提交</button>
               <el-button type="primary" :loading="true" class="contact_submit_btn" v-if="leaveSubmitting===1">提交</el-button>
             </div>
             <div style="width: 17rem;height: 4rem;background-color: rgb(238,238,238);color: #777;text-align: center;line-height: 4rem;margin: 0 auto" v-if="leaveSubmit===0">
               Thanks for your submission!
             </div>
           </div>
         </div>
        <div class="right_map_box">
            <el-amap ref="map" vid="amapDemo"  :center="center" :zoom="zoom" :plugin="plugin" :events="events" class="amap-demo">
              <el-amap-marker v-for="marker in markers" :position="marker.position" :key="marker.key"></el-amap-marker>
            </el-amap>
          <div class="company_card_box">
            <div class="company_card_list">
              <i class="el-icon-location" ></i>
              <span class="company_card_span">厦门思明区观日路18号601-3</span>
            </div>
            <div class="company_card_list">
              <i class="el-icon-mobile-phone"></i>
              <span class="company_card_span">0592-5535810</span>
            </div>
            <div class="company_card_list">
              <i class="el-icon-message"></i>
              <span class="company_card_span">hotbuybuy@qq.com</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_about_contact">
      <div class="inside_about_contact">
        <div class="bottom_logo_box">
          <img src="../assets/image/index/logo.jpg" style=" width: 100%;height: auto" alt=""/>
        </div>
        <div class="bottom_about_us">
           <span class="bottom_span_title">关于我们</span>
           <span class="bottom_span_content">我们的理念</span>
           <span class="bottom_span_content">我们的历史</span>
        </div>
        <div class="bottom_contact_us">
          <span class="bottom_span_title">联系我们</span>
          <span class="bottom_span_content">0592-5535810</span>
          <span class="bottom_span_content">hotbuybuy@qq.com</span>
        </div>
        <div class="we_chat_box">
        </div>
      </div>
    </div>
    <div class="bottom_icp_box">
      <a href="https://beian.miit.gov.cn/#/Integrated/index" class="bottom_icp_a" >闽ICP备20004855号-1</a>
    </div>
    <div>
      <el-dialog
        title=""
        :visible.sync="noneCommodity"
        width="20%"
        center
      >
        <span style="display: block;padding: 0.5rem 0;font-size: 1.3rem;font-weight: 500"> 您的购物车为空</span>
        <span slot="footer" class="dialog-footer">
              <el-button style="width: 60%;background: rgb(253,192,6);border: none;color: white" @click="closeCommodity">继续购物</el-button>
            </span>
      </el-dialog>
    </div>
    <shoppingCar  @carDialogClose="carDialogClose" :dialog-table-visible="dialogTableVisible"></shoppingCar>
  </div>

</template>

<script>
  // import { AMapManager } from 'vue-amap';
  import shoppingCar from "./common/shoppingCar";
    export default {
      name: "index",
      components:{
        shoppingCar
      },
      data(){
          return{
            fruitList:[
              {id:1,name:'平和蜜柚',image:require('../assets/image/index/strawberry.jpg')},
              {id:2,name:'葡萄',image:require('../assets/image/index/grape.jpg')},
              {id:3,name:'火龙果',image:require('../assets/image/index/pitaya.jpg')},
              {id:4,name:'芒果',image:require('../assets/image/index/mango.jpg')},
              {id:5,name:'黄金百香果',image:require('../assets/image/index/passion.jpg')},
              {id:6,name:'哈密瓜',image:require('../assets/image/index/aBoxstrawberries.jpg')},
            ],
            commodityList:[
              {id:1,name:'榴莲',image:require('../assets/image/index/durian.png'),price:'118.98',introduce:'金枕榴莲新鲜带壳香甜软糯【爆甜】，批发进口',num:null},
              {id:2,name:'西瓜',image:require('../assets/image/index/watermelon.png'),price:'19.90',introduce:'麒麟西瓜现摘脆甜皮薄 新鲜现发',num:null},
              {id:3,name:'菠萝',image:require('../assets/image/index/pineapple.jpg'),price:'9.70',introduce:'海南金钻凤梨 现摘现发',num:null},
              {id:4,name:'猕猴桃',image:require('../assets/image/index/litchi.jpg'),price:'33.80',introduce:'陕西绿心猕猴桃 当季水果非红心黄心 批发',num:null},
              {id:5,name:'哈密瓜',image:require('../assets/image/index/aBoxstrawberries.jpg'),price:'52.00',introduce:'正宗新疆爆甜哈密瓜 孕妇应季新鲜水果',num:null},
              {id:6,name:'水晶梨',image:require('../assets/image/index/pear.jpg'),price:'7.80',introduce:'河北大鸭梨水晶梨 产地直发 新鲜包邮',num:null},
              {id:7,name:'人参果',image:require('../assets/image/index/sapodilla.jpg'),price:'8.79',introduce:'云南石林人参果，精品圆果 成熟黄肉人参果',num:null},
              {id:8,name:'红毛蟠桃',image:require('../assets/image/index/flatPeach.jpg'),price:'18.60',introduce:'山东红毛蟠桃扁桃 新鲜脆甜',num:null},
            ],
            specialList:[
              {id:16,name:'芭乐',introduce:'低糖水果，广西番石榴白心芭乐 10斤',image:require('../assets/image/index/guava.jpg'),price:25.8,orPrice:32.6,num:null},
              {id:17,name:'冰糖橙',introduce:'手剥青绿甜橙，云南冰糖橙 10斤',image:require('../assets/image/index/orange.jpg'),price:18.32,orPrice:25.6,num:null},
              {id:18,name:'雪莲果',introduce:'新鲜现挖，云南天山红心雪莲果 5斤',image:require('../assets/image/index/snowLotus.jpg'),price:12.9,orPrice:20.35,num:null},
              {id:19,name:'柿子',introduce:'新鲜采摘，阳丰柿子 10斤',image:require('../assets/image/index/persimmon.jpg'),price:25.5,orPrice:33.5,num:null},
            ],
            formInline:{
               user:'',
               email:''
            },
            haveMore:true,
            name:'',
            email:'',
            flag:1,
            value:'',
            mouseIndex:0,
            submit:1,
            leaveSubmit:1,
            submitting:0,
            leaveSubmitting:0,
            unEmail:false,
            leaveUnEmail:false,
            zoom: 17.5,
            center: [118.178275, 24.486208],
            markers: [
              {
                position: [118.177884, 24.4863],
                key:1,
                visible: true,
                draggable: false,
                template: '<span>1</span>',
              }
            ],
            events: {},
            plugin: ['ToolBar', {
              pName: 'MapType',
              defaultType: 0,
            }],
            allCount:0,
            dialogTableVisible:false,
            noneCommodity:false

          }
      },
      created(){
        let that=this;
        document.addEventListener('scroll', this.handleScroll);
        that.allCount=sessionStorage.getItem('allCount')? sessionStorage.getItem('allCount'):0;
      },
      methods:{
        onSubmit(){
          let that=this;
          if(that.formInline.user!==''&&that.formInline.email!==''){
            that.submiting=1;
            let strRegex = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
            if(!strRegex.test(that.formInline.email)){
              that.unEmail=true;
              that.submiting=0;
              return false;
            }else{
              setTimeout(() =>{
                that.submit=0;
              },800);
            }

          }
        },
        submitMessage(){
          let that=this;
          if(that.name!==''&&that.email!==''){
            that.leaveSubmitting=1;
            let strRegex = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
            if(!strRegex.test(that.email)){
              that.leaveUnEmail=true;
              that.leaveSubmitting=0;
              return false;
            }else{
              setTimeout(() =>{
                that.leaveSubmit=0;
              },800);
            }
          }
        },
        handleScroll(){
          let that=this;
          let a = document.getElementsByClassName('page')[0].offsetHeight;
           if(window.pageYOffset>100){
             that.flag=2;
           }else{
             that.flag=1;
           }
        },
        mouseOver(index){
          let that=this;
          that.mouseIndex=index;
        },
        mouseLeave(index){
          let that=this;
          that.mouseIndex=0;
        },
        seeMore(){
          let that=this;
          let newList=[
            {id:9,name:'平和蜜柚',image:require('../assets/image/index/strawberry.jpg'),price:'59.90',introduce:'正宗平和琯溪蜜柚红肉蜜柚 应季水果批发',num:null},
            {id:10,name:'葡萄',image:require('../assets/image/index/grape.jpg'),price:'16.80',introduce:'夏黑葡萄无籽 整箱批发 果园直发云南高山高档水果',num:null},
            {id:11,name:'火龙果',image:require('../assets/image/index/pitaya.jpg'),price:'9.80 ',introduce:'红心火龙果 金都一号新鲜现摘 正向直发 批发价包邮',num:null},
            {id:12,name:'芒果',image:require('../assets/image/index/mango.jpg'),price:'16.90',introduce:'攀枝花芒果凯特大芒果 新鲜水果 核包柔厚',num:null},
            {id:13,name:'黄金百香果',image:require('../assets/image/index/passion.jpg'),price:'15.90',introduce:'福建黄金百香果 应急新鲜水果 黄皮整箱批发',num:null},
            {id:14,name:'玫瑰青提',image:require('../assets/image/index/aGrape.jpg'),price:'18.90',introduce:'阳光玫瑰青提 葡萄香印青提 大果无籽 甜蜜多汁',num:null},
            {id:15,name:'鸡蛋',image:require('../assets/image/index/ege.jpg'),price:'17.99',introduce:'正宗土鸡蛋 散养农村柴鸡蛋 新鲜饱满 营养均衡20枚现捡现发',num:null},
          ]
          that.commodityList=that.commodityList.concat(newList);
          this.haveMore=false;
        },
        bugThing(data){
          let that=this;
          data=JSON.stringify(data);
          that.$router.push({
            path:'/detail',
            query:{data:data}
          })
        },
        carDialogClose(val){
          let that=this;
          that.dialogTableVisible=val;
          that.allCount=sessionStorage.getItem('allCount')? sessionStorage.getItem('allCount'):0;
        },
        seeCar(){
          let that=this;
          let carList=sessionStorage.getItem('shoppingCarList');
          if(carList!==undefined && carList!==null && carList !== '[]'){
            that.dialogTableVisible=true;
            that.noneCommodity=false;
          }else{
            that.noneCommodity=true;
            that.dialogTableVisible=false;
          }
        },
        closeCommodity(){
          let that=this;
          that.noneCommodity=false;
          that.allCount=sessionStorage.getItem('allCount')? sessionStorage.getItem('allCount'):0;
        },

      },
      beforeDestroy () {
        document.removeEventListener('scroll', this.handleScroll);
      },
    }
</script>

<style scoped>
  html,body{
    padding: 0;
    margin: 0;
    border: 0;
  }
  .top_nav_bg{
    width: 100%;
    height: 40rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .top_box{
    width: 100%;
    height: 5rem;
    display: flex;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .top_box_tow{
    width: 100%;
    height: 5rem;
    display: flex;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    background-color: white;
    border-bottom: 1px solid rgb(217,217,217);
    z-index: 999;
  }
  .left_logo_nav{
    width: 35%;
    height: 5rem;
    display: flex;
    justify-content: space-between;
  }
  .left_logo_box{
    width: 6%;
    height: 5rem;
    padding: 1rem 3rem;
   }
  .left_nav_box{
    width: 80%;
    height: 5rem;
    line-height: 3rem;
  }
  .right_car_store{
    width: 12%;
    height: 5rem;
    color: black;
    display: flex;
    align-items: center;
  }
  .list_style{
    list-style-type: none;
  }

  .list_a_style{
    text-decoration: none;
    cursor:hand;
    color: black;
    font-weight: 600;
  }
  .show_store_btn{
    width: 9rem;
    height: 3rem;
    color: white;
    background-color: rgb(253,192,6);
    border: none;
    font-size: 1.2rem;
    font-weight: 600;
    margin-left: 1.6rem;
    text-align: center;
    line-height: 3rem;
    text-decoration: none;
  }
  .other_store_btn{
    width: 9rem;
    height: 3rem;
    color: black;
    border: none;
    font-size: 1.2rem;
    font-weight: 600;
    margin-left: 1.6rem;
    background-color: transparent;
    text-align: center;
    line-height: 3rem;
    text-decoration: none;
  }
  .about_us_box{
    width: 100%;
    height:13.5rem;
    background: white;
    margin-top: 5rem;
  }
  .about_chinese_title{
    width: 100%;
    height: 3rem;
    font-size: 1.8rem;
    font-weight: 600;
    text-align: center;
    line-height: 3rem;
    margin-top: 1rem;
  }
  .about_us_content{
    width: 80%;
    height: 10rem;
    margin: 2rem auto;
    font-size: 1.3rem;
    text-align: center;
  }
  .hot_sale_fruits{
    width: 100%;
    height: 27rem;
    background: rgb(249,249,249);
  }
  .sale_chinese_title{
    width: 84%;
    height: 3rem;
    text-align: left;
    line-height: 3rem;
    color: black;
    font-size: 1.5rem;
    font-weight: 500;
    margin: 0 auto;
    padding: 1rem 0;
  }
  .sale_fruits_box{
    width: 84%;
    height: 22rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
  }
  .one_fruits_box{
    width: 11.6rem;
    height: 16.1rem;
    padding: 0 2rem
  }
  .all_commodity_box{
    width: 100%;
    min-height: 60rem;
    background: rgb(249,249,249);
  }
  .all_chinese_title{
    width:84%;
    height: 3rem;
    text-align: left;
    line-height: 3rem;
    font-size: 1.5rem;
    color: black;
    margin: 0 auto;
    padding: 1rem 0;
  }
  .show_commodity_box{
    width: 85%;
    min-height: 47rem;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
  }
  .one_commodity_box{
    width: 23.5rem;
    height: 25rem;
    position: relative;
    overflow: hidden;
    border: 1px solid #F5F6F9;
    margin: 0.5rem;
    background: white;
  }
  .one_mask_commodity{
    width: 23.5rem;
    height: 18.5rem;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex ;
    justify-content: center;
    align-items: center;
  }
  .button_style{
    width: 6rem;
    height: 3rem;
    display: block;
    text-align: center;
    line-height: 3rem;
    font-weight: bold;
    cursor:pointer;
  }
  .bug_btn{
    background-color: rgb(254,193,6);
    color: white;
    width: 6rem;
    height: 3rem;
    animation:mymove 1s infinite;
    -webkit-animation:mymove 1s infinite;
    animation-iteration-count: 1;
  }
  @keyframes mymove
  {
    from {  margin-top: 20px}
    to {  margin-top: 0}
  }
  .bug_btn_tow{
    animation:mymove 2s infinite;
    -webkit-animation:myleave 2s infinite;
    animation-iteration-count: 1;
    display: none;
  }
  @keyframes myleave
  {
    from {  margin-top: 0}
    to {  margin-top: 100px}
  }
  .logistics_box{
    width: 100%;
    height: 34rem;
    background: rgb(249,249,249);
  }
  .truck_and_word{
    width: 65rem;
    height: 23rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .truck_image_box{
    width: 20rem;
    height: auto;
    display: flex;
  }
  .logistics_word_box{
    width: 30rem;
    height: 15rem;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(245,241,241);
    border-radius: 50%/50%;
  }

  .join_us_box{
    width: 100%;
    height: 26rem;
    background: rgb(249,249,249);
  }
  .join_chinese_title{
    width: 100%;
    text-align: center;
    font-size: 1.8rem;
    font-weight: 600;
    padding-top: 3rem;
  }
  .join_english_title{
    width: 100%;
    height: 2.5rem;
    line-height: 2.5rem;
    color: #fddf50;
    letter-spacing: 2.4px;
    text-align: center;
    padding-top: 0.5rem;
  }
  .join_email_box{
    width: 100%;
    text-align: center;
    height: 5rem;
    margin-top: 4rem;
  }
  .join_email_box /deep/ .el-input__inner {
    color: #606266;
    height: 49px;
    border: none;
    background: rgb(246,246,246);
    width: 15rem;
  }
  .join_email_box /deep/ input::-webkit-input-placeholder{
    font-size: 1.2rem;
  }
  .join_email_box /deep/ input::-ms-input-placeholder{
    font-size: 1.2rem;
  }
  .contact_and_map{
    width: 100%;
    height: 43rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .inside_contact_map{
    width: 76rem;
    height: 33.5rem;
    border: 1px solid #b7b7bc;
    display: flex;
  }
  .small_contact_map{
    width: 76rem;
    height: 20.5rem;
    border: 1px solid #b7b7bc;
    display: flex;
  }
  .contact_us_box{
    width:50%;
    height: 100%;
  }
  .right_map_box{
    width: 50%;
    height: 100%;
    position: relative;
  }
  .contact_english_title{
    width: 100%;
    text-align: center;
    color: #fddf50;
    font-size: 1rem;
    letter-spacing: 2.4px;
    padding-top: 3rem;
  }
  .contact_chinese_title{
    width: 100%;
    height: 3rem;
    text-align: center;
    font-size: 1.8rem;
    color: black;
    font-weight: 600;
    padding-top: 0.5rem;
  }
  .contact_name_input /deep/ .el-input__inner {
    color: #606266;
    width: 33rem;
    height: 3rem;
    border: none;
    background: rgb(246,246,246);
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
  }
  .contact_leaving_message{
    width:32rem;
    height: 8rem;
    border: none;
    background: rgb(246,246,246);
    margin-bottom: 0.5rem;
    padding: 0.5rem;
    font-size: 1.2rem;
  }
  .contact_leaving_message /deep/ input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    font-size: 1em;
    color: rgb(195,200,216);
    padding: 0.5rem;
    font-weight: 500;
  }
  .contact_leaving_message /deep/ input:-moz-placeholder,textarea:-moz-placeholder {
    font-size: 1rem;
    color: rgb(195,200,216);
    font-weight: 500;
  }
  .contact_leaving_message /deep/ input::-moz-placeholder,textarea::-moz-placeholder {
    font-size: 1rem;
    color: rgb(195,200,216);
    font-weight: 500;
  }
  .contact_leaving_message /deep/ input:-ms-input-placeholder,textarea:-ms-input-placeholder {
    font-size: 0.8rem;
    color: rgb(195,200,216);
    font-weight: 500;
  }
 textarea{
    outline: none;
  }
  .contact_submit_btn{
    width: 32.8rem;
    height: 2.5rem;
    background-color: rgb(255,190,6);
    border: none;
    color: white;
    font-weight: 500;
  }
  .company_card_box{
    width: 14.5rem;
    height: 9.75rem;
    background-color: white;
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
    z-index: 9;
  }
  .company_card_list{
    font-size: 1.1rem;
    padding: 0.5rem 0.5rem;
    display: flex
  }
  .company_card_span{
    width:10rem;
    word-break:break-all;
    padding: 0 0.5rem;
    font-size:1rem;
  }
  .bottom_about_contact{
    width: 100%;
    height: 9.75rem;
  }
  .inside_about_contact{
    width: 80%;
    height: 100%;
    margin: 0 auto;
    border-top: 1px solid rgb(217,217,217);
    display: flex;
    padding-top: 1.5rem;
  }
  .bottom_logo_box{
    width: 9rem;
    height: 100%;
  }
  .bottom_about_us{
    width: 6rem;
    height: 75%;
    margin-left: 10rem;
    margin-top: 3%
  }
  .bottom_contact_us{
    width: 9rem;
    height: 75%;
    margin-left: 10rem;
    margin-top: 3%
  }
  .bottom_span_title{
    display: block;
    font-size: 0.85rem;
    font-weight: bolder;
    padding: 0.2rem 0
  }
  .bottom_span_content{
    display: block;
    font-size: 0.85rem;
    padding: 0.2rem 0;
    color: #1B1B1F;
  }
  .we_chat_box{
    width: 2rem;
    height: 2rem;
    margin-left: 30rem;
    margin-top: 4rem;
  }
  .bottom_icp_box{
    width: 100%;
    height: 6rem;
    line-height: 6rem;
    text-align: center;
    color: #555;
    font-size: 0.85rem;
  }
  .think_for_submit{
    width: 7.8rem;
    height: 4rem;
    background-color: rgb(238,238,238);
    color: #777;
    text-align: center;
    line-height: 4rem;
    margin: 0 auto;
  }
  .see_more_commodity{
    width: 100%;
    height: 2rem;
    text-align: center;
    line-height: 2rem;
    padding: 0.5rem 0;
  }
  .special_offer_fruits{
    width: 100%;
    height: 36rem;
    background: rgb(249,249,249);
  }
  .special_offer_title{
    width: 84%;
    height: 3rem;
    text-align: left;
    line-height: 3rem;
    font-size: 1.5rem;
    font-weight: 500;
    margin: 0 auto;
    padding: 1rem;
  }
  .special_fruits_box{
    width: 84%;
    height: 30rem;
    margin: 0 auto;
    display: flex;
  }
  .one_special_offer{
    width: 23.5rem;
    height: 30rem;
    position: relative;
    overflow: hidden;
    border: 1px solid #F5F6F9;
    margin: 0.5rem;
    background: white;
  }
  .one_special_offer:hover{
    transform: scale(1.03);
    transition: all ease 0.3s;
    box-shadow:0px 0px 10px rgba(0, 0, 0, .04);
  }
  .special_fruits_image{
    width: 23.5rem;
    height: 17.5rem;
    overflow: hidden;
    object-fit: cover;
    margin-top: 0.5rem;
    text-align: center;
  }
  .bottom_icp_a{
    color: #999;
    text-decoration: none;
  }
  .bottom_icp_a:hover{
    color: rgb(255,190,6);
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue